import international from '@plebiscito/plebiscito/contextData/international'
import { ELECTIONS_PROPERTIES, KEY_ORDER } from '@plebiscito/plebiscito/helpers'
import _ from 'lodash'

export const getCurrentResults = (dataByTerritory, discartedCountriesPeople = 0) => {
  const { optionA, optionB } = ELECTIONS_PROPERTIES[dataByTerritory[0].electionKey]
  const { padron, participation, total, totalOptionA, totalOptionB } = getStatsSummary(
    dataByTerritory,
    optionA,
    optionB,
    discartedCountriesPeople
  )
  const preliminar = !(dataByTerritory[0].OFICIAL === 'true')
  const winner = totalOptionA && totalOptionB && totalOptionA !== totalOptionB
    ? totalOptionA > totalOptionB
      ? optionA.label
      : optionB.label
    : undefined
  return {
    participation: {
      countedVotes: Math.min(total, padron),
      percentage: Math.min(participation * 100, 100),
      totalVotes: padron,
    },
    preliminar,
    winner,
  }
}

export const getCardsResults = (dataByTerritory, discartedCountriesPeople) => {
  const { optionA, optionB, shortLabel } = ELECTIONS_PROPERTIES[dataByTerritory[0].electionKey]
  const { fractionOptionA, fractionOptionB, totalOptionA, totalOptionB } = getStatsSummary(
    dataByTerritory,
    optionA,
    optionB,
    discartedCountriesPeople
  )
  const winner = totalOptionA && totalOptionB && totalOptionA !== totalOptionB
    ? totalOptionA > totalOptionB
      ? optionA.label
      : optionB.label
    : undefined
  return {
    key: dataByTerritory[0].electionKey,
    options: [
      {
        key: optionA.field,
        percentage: fractionOptionA * 100,
        title: optionA.label,
        votes: totalOptionA,
      },
      {
        key: optionB.field,
        percentage: fractionOptionB * 100,
        title: optionB.label,
        votes: totalOptionB,
      },
    ],
    title: shortLabel,
    winner,
  }
}
export const getStatsSummary = (electionData, optionA, optionB, discartedCountriesPeople = 0) => {
  const totalOptionA = _.sumBy(electionData, (territory) => territory[optionA.field] || 0)
  const totalOptionB = _.sumBy(electionData, (territory) => territory[optionB.field] || 0)
  const totalBlank = _.sumBy(electionData, (territory) => territory.BLANCO || 0)
  const totalNull = _.sumBy(electionData, (territory) => territory.NULO || 0)
  const padron = _.sumBy(electionData, (territory) => territory.TOTAL_VOTANTES || 0) + discartedCountriesPeople
  const totalValid = totalOptionA + totalOptionB
  const divisor = totalValid === 0 ? 1 : totalValid
  const fractionOptionA = totalOptionA / divisor
  const fractionOptionB = totalOptionB / divisor
  const total = totalValid + totalBlank + totalNull
  const participation = total / padron
  return {
    fractionOptionA,
    fractionOptionB,
    padron,
    participation,
    total,
    totalBlank,
    totalNull,
    totalOptionA,
    totalOptionB,
    totalValid,
  }
}

export const getCardsData = ({ current, pEntrada, pSalida, sVuelta }) => {
  const allElectionsData = [
    ...pSalida.internacional.map((t) => ({
      ...t,
      electionKey: ELECTIONS_PROPERTIES.pSalida.electionKey,
    })),
    ...pEntrada.internacional.map((t) => ({
      ...t,
      electionKey: ELECTIONS_PROPERTIES.pEntrada.electionKey,
    })),
    ...sVuelta.internacional.map((t) => ({
      ...t,
      electionKey: ELECTIONS_PROPERTIES.sVuelta.electionKey,
    })),
  ]

  const dataByCountry = _.groupBy(allElectionsData, 'N_KEY')
  delete dataByCountry['NaN']
  const discartedCountriesPeople = allElectionsData.find(({ N_KEY }) => 't.p.otros' === N_KEY)?.TOTAL_VOTANTES || 0
  delete dataByCountry['t.p.otros']
  const dataByElection = Object.entries(dataByCountry)
    .map(([countryKey, territories]) => ({
      countryKey,
      electionsData: _.groupBy(territories, 'electionKey'),
    }))
  const results = dataByElection.map(({ countryKey, electionsData }) => {
    const sections = Object.entries(electionsData)
      .map((territories) => getCardsResults(territories[1], discartedCountriesPeople))
      .sort((t1, t2) => {
        const order = KEY_ORDER.findIndex((key) => key === t1.key)
          - KEY_ORDER.findIndex((key) => key === t2.key)
        return order
      })
    const { participation, preliminar, winner } = getCurrentResults(
      Object.entries(electionsData)[0][1],
      discartedCountriesPeople
    )
    return {
      participation,
      preliminar,
      sections,
      timestamp: current.updated_at,
      title: international.find((country) => {
        return country.N_KEY === countryKey
      }).LABEL,
      winner,
    }
  })
  return results
}
